import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';
import { queryClient } from './lib/queryClient';
import { installSessionGuard } from './lib/sessionExpired';
import './index.css';

// Before anything can issue a request: one fetch wrapper that turns a 401 from our backend
// into an honest "your session has ended" takeover, instead of each call site reporting a
// dead session as its own inexplicable failure.
installSessionGuard();

createRoot(document.getElementById('root')).render(
  <QueryClientProvider client={queryClient}>
    <RouterProvider router={router} />
    <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
  </QueryClientProvider>,
);
